module.exports = __webpack_public_path__ + "static/b2-85ace66e628cab8f0bbcb219473f6d56.png";